import { ApiProvider } from "../utilities/Provider";
import { handleError, handleResponse } from "../utilities/Response";

const provider = ApiProvider();
const url = 'search';

const buscar = (coleccion, termino) => {
    return provider.getAll(`${ url }/${ coleccion }/${ termino }`)
        .then( handleResponse )
        .catch( handleError )
}

const apiBusquedas = {
    buscar
}

export default apiBusquedas;